import {
  toast,
  ToastContainer as ToastifyToastContainer,
} from "react-toastify";
import "./Toast.css";
import Alert from "./Alert";

interface NotifyArgs {
  message: string;
  variant?: "info" | "error" | "warning";
  autoCloseTime?: number;
}

export const notify = ({
  message,
  variant = "info",
  autoCloseTime = 5000,
}: NotifyArgs) => {
  const icon = {
    info: "check-circle",
    error: "exclamation-circle",
    warning: "exclamation-circle",
  }[variant];

  toast(
    <Alert
      dataCy={`toast_${variant}`}
      title={message}
      variant={variant}
      icon={icon}
    />,
    {
      autoClose: autoCloseTime,
    },
  );
};

export const ToastContainer = () => (
  <ToastifyToastContainer
    pauseOnHover
    newestOnTop
    closeOnClick
    position="bottom-center"
    hideProgressBar
    autoClose={5000}
    closeButton={false}
    rtl={false}
    pauseOnFocusLoss={false}
    draggable={false}
  />
);
